import firstImg from "../../assest/about/about1.jpg";
import calender from "../../assest/calender.svg";
import clock from "../../assest/clock.svg";
import location from "../../assest/location.svg";
import Img1 from "../../assest/popularEvents/lines1.svg";
import Img2 from "../../assest/popularEvents/circles1.svg";
import Img3 from "../../assest/popularEvents/circles2.svg";
import Img4 from "../../assest/popularEvents/dots3.svg";
import Img5 from "../../assest/popularEvents/circles3.svg";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { useEvent } from "../../context/EventContext";
import { motion } from "framer-motion";
import Button1 from '../../components/shared/Button1';

const events = [
  {
    image: "https://eventics.temptics.com/assets/img/reviewer-1.png",
  },
  {
    image: "https://eventics.temptics.com/assets/img/reviewer-2.png",
  },
  {
    image: "https://eventics.temptics.com/assets/img/reviewer-2.png",
  },
  {
    image: "https://eventics.temptics.com/assets/img/reviewer-3.png",
  },
];

// Event Banner Variants
const HeadingVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1 },
  },
};

const graphicVariants = {
  hidden: { opacity: 0, rotate: 100 },
  visible: { opacity: 1, rotate: 0, transition: { duration: 1.5 } },
};

const buttonVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const leftImgVariants = {
  hidden: { opacity: 0, x: -150 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.5 } },
};

const rightContentVariants = {
  hidden: { opacity: 0, x: 150 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.5 } },
};

const EventBanner = () => {
  return (
    <div className="eventBanner">
      <motion.img
        variants={leftImgVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        src={firstImg}
        alt="img"
      />
      <motion.div
        variants={rightContentVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div>
          <img src={calender} alt="icon" />
          <span>07/Aug/2024</span> |
          <img src={clock} alt="icon" />
          <span>10:00 am to 02.00 pm</span>
        </div>
        <div>
          <p>
            Join us at The Big Meet, an exhilarating corporate event designed to
            bring together industry leaders and innovators. Experience engaging
            sessions, insightful discussions, and unparalleled networking
            opportunities.
          </p>
          <button>Buy Tickets</button>
          <div className="speakers-btn">
            {events.map((event, index) => {
              return (
                <div key={index}>
                  <img src={event.image} alt="speaker-img" />
                </div>
              );
            })}
            <span>Speakers</span>
          </div>
        </div>
        <div>
          <img src={location} alt="icon" />
          <p>135 W, 46nd Street, New York</p>
        </div>
      </motion.div>
    </div>
  );
};

// Component to render popular events on the home page
const PopularEvents = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { setIsModalOpen } = useEvent();

  //   Handles the "Create Event" button click by setting the isModalOpen state to true if the user is loggedIn
  //   and navigates to the login page if the user is not loggedIn
  const handleCreateEvent = () => {
    if (isLoggedIn) {
      setIsModalOpen(true);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="popular-events">
      <motion.h2
        variants={HeadingVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="sectionHeading"
      >
        POPULAR EVENTS
      </motion.h2>
      <motion.img
        variants={graphicVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        src={Img1}
        alt="graphic"
        className="img1"
      />
      <motion.img
        variants={graphicVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        src={Img2}
        alt="graphic"
        className="img2"
      />
      <motion.img
        variants={graphicVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        src={Img3}
        alt="graphic"
        className="img3"
      />
      <motion.img
        variants={graphicVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        src={Img4}
        alt="graphic"
        className="img4"
      />
      <motion.img
        variants={graphicVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        src={Img5}
        alt="graphic"
        className="img5"
      />
      <div>
        <motion.div
          variants={buttonVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="create-event"
          onClick={() => handleCreateEvent()}
        >
        <Button1>Create Event</Button1>
        </motion.div>
        <div>
          <EventBanner />
          <EventBanner />
          <EventBanner />
        </div>
      </div>
    </div>
  );
};

export default PopularEvents;
